import React from 'react';
import PropTypes from 'prop-types';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import Card from '@/modules/common/components/Card';
import Error from '@/modules/common/components/Error';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import Table from './Table';

const History = (props) => {
    return (
        <Card id="lead-history">
            <CardHeader title="История изменений"/>
            <CardContent className={(props.loading) ? 'loading' : ''}>
                {(!props.loading)
                    ? <>
                        {(props.history)
                            ? <>
                                {(props.history.length > 0)
                                    ? <Table history={props.history}/>
                                    : <Error><Typography>История изменений не найдена</Typography></Error>
                                }
                            </>
                            : <ErrorFetch onClick={() => props.fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </CardContent>
        </Card>
    );
};

History.propTypes = {
    loading: PropTypes.bool.isRequired,
    history: PropTypes.array,
    fetch: PropTypes.func.isRequired,
};

export default History;
